@import '../../style/index';

:host {
  display: block;
  margin-top: var(--spacings-xl);
  position: relative;

  .banner {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: rem-calc(32px);

    @include medium-up {
      padding: rem-calc(96px);
    }

    @include large-up {
      padding: 0;
    }
  }

  .overlay {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(to bottom right, #000, #000);
      opacity: var(--colors-stage-banner-dark-opacity);
    }
  }

  .headline,
  .subline {
    text-align: center;

    @include layer-normal-top;

    @include large-up {
      max-width: 50vw;
      margin: 0 auto;
    }
  }

  .headline {
    margin-bottom: var(--spacings-s);
  }

  .subline {
    margin-bottom: var(--spacings-l);
  }

  .buttons {
    display: flex;
    flex-direction: row;
    gap: var(--spacings-s);
    align-items: center;
    justify-content: center;

    &:has(:nth-child(2)) {
      @media (max-width: rem-calc(480px)) {
        flex-direction: column;
        width: 100%;

        rcm-button {
          width: 100%;
        }
      }
    }
  }
}
